import React from 'react';
import { cn } from '@/lib/utils';

const logomarkSrc = `${process.env.PUBLIC_URL || ''}/assets/malaika-logomark.png`;

export function BrandMark({ compact = false, inverse = false, className }) {
  return (
    <div className={cn('flex items-center gap-3 min-w-0', className)}>
      <div
        className={cn(
          'brand-mark flex shrink-0 items-center justify-center overflow-hidden',
          compact ? 'h-10 w-10' : 'h-11 w-11',
          inverse && 'brand-mark-inverse'
        )}
      >
        <img
          src={logomarkSrc}
          alt=""
          className="h-full w-full object-contain"
          aria-hidden="true"
        />
      </div>
      {!compact && (
        <div className="min-w-0">
          <div className={cn('brand-wordmark text-xl font-medium leading-none', inverse ? 'text-[#FAFAF7]' : 'text-foreground')}>
            MALA'IKA<span className={inverse ? 'text-[#C9A961]' : 'text-primary'}>.</span>
          </div>
          <div className={cn('mt-1 text-[11px] font-medium uppercase tracking-[0.12em]', inverse ? 'text-[#FAFAF7]/70' : 'text-muted-foreground')}>
            Emergency Response Platform
          </div>
        </div>
      )}
    </div>
  );
}

export default BrandMark;
